(() => {
  const data = window.ThemeDlRedirect;
  const rules = (data && data.rules) || [];
  if (!rules.length) return;

  const pageProductTitle = data.pageProductTitle || null;
  const pageProductHandle = data.pageProductHandle || null;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const buildCheckoutUrl = (variantId) =>
    '/cart/clear?return_to=' +
    encodeURIComponent('/cart/add?id=' + variantId + '&quantity=1&return_to=/checkout');

  const isDownloadProduct = (rule, handle, title, productId) => {
    const h = (handle || '').toLowerCase();
    const t = norm(title);
    const dlHandle = (rule.downloadHandle || '').toLowerCase();
    if (dlHandle && h === dlHandle) return true;
    if (rule.downloadProductId && productId && String(productId) === String(rule.downloadProductId)) return true;
    const aliases = rule.downloadHandleAliases || [];
    for (let i = 0; i < aliases.length; i++) {
      if (h === String(aliases[i]).toLowerCase()) return true;
    }
    const titleAliases = rule.downloadTitleAliases || [];
    for (let j = 0; j < titleAliases.length; j++) {
      if (t === norm(titleAliases[j])) return true;
    }
    return false;
  };

  const isDemoTitle = (rule, title) => {
    const t = norm(title);
    const prefix = norm(rule.demoTitlePrefix);
    if (!t || !prefix) return false;
    if (isDownloadProduct(rule, '', title, '')) return false;
    return t.indexOf(prefix) === 0;
  };

  const handleMatchesDemo = (rule, handle) => {
    const needle = (rule.demoHandleContains || '').toLowerCase();
    if (!needle) return false;
    return (handle || '').toLowerCase().indexOf(needle) !== -1;
  };

  const matchRuleForCard = (root, handleAttr, title) => {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      if (handleAttr && isDownloadProduct(rule, handleAttr, '', '')) continue;
      if (handleAttr && handleMatchesDemo(rule, handleAttr)) return rule;
      if (title && isDemoTitle(rule, title)) return rule;
    }
    return null;
  };

  const titleFromCard = (root) => {
    if (!root) return '';
    const sel =
      '.card__heading, .product-title, .bls__product-name, .bls__product-title, h3, h2, .card-information__text, a[href*="/products/"]';
    const nodes = root.querySelectorAll(sel);
    for (let i = 0; i < nodes.length; i++) {
      const text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) continue;
      for (let r = 0; r < rules.length; r++) {
        if (isDemoTitle(rules[r], text)) return text;
      }
    }
    return '';
  };

  const cardRule = (el) => {
    if (!el) return null;
    const root =
      el.closest(
        '[data-product-handle], .bls__product-item, .product-item, .card-wrapper, .product-card, .grid__item, product-card, li, article'
      ) || el;
    const handleAttr = root.getAttribute && root.getAttribute('data-product-handle');
    const title = titleFromCard(root);
    return matchRuleForCard(root, handleAttr, title);
  };

  const pageRule = () => {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      if (pageProductHandle && isDownloadProduct(rule, pageProductHandle, pageProductTitle, rule.downloadProductId)) {
        continue;
      }
      if (pageProductTitle && isDemoTitle(rule, pageProductTitle)) return rule;
      if (pageProductHandle && handleMatchesDemo(rule, pageProductHandle)) return rule;
    }
    const h1 = document.querySelector('h1.product__title, h1.bls__product-title, .main-product h1, h1');
    if (h1) {
      for (let j = 0; j < rules.length; j++) {
        if (isDemoTitle(rules[j], h1.textContent)) return rules[j];
      }
    }
    return null;
  };

  const resolveRule = (el) => pageRule() || cardRule(el);

  const goCheckout = (e, rule) => {
    if (!rule || !rule.variantId) return;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    window.location.assign(buildCheckoutUrl(String(rule.variantId)));
  };

  const isAtcButton = (el) =>
    el &&
    el.closest(
      'button[name="add"], a[name="add"].product-form__submit, button.product-form__submit, .product-form__submit, .bls__js-addtocart, [data-add-to-cart], button[type="submit"][name="add"], a.js-theme-demo-checkout-buy'
    );

  document.addEventListener(
    'click',
    (e) => {
      const btn = isAtcButton(e.target);
      if (!btn) return;
      if (btn.classList && btn.classList.contains('js-theme-demo-checkout-buy')) return;
      const rule = resolveRule(btn);
      if (!rule) return;
      goCheckout(e, rule);
    },
    true
  );

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form) return;
      const isCartForm =
        form.getAttribute('data-type') === 'add-to-cart-form' ||
        (form.action && String(form.action).indexOf('/cart/add') !== -1);
      if (!isCartForm) return;
      const rule = resolveRule(form);
      if (!rule) return;
      goCheckout(e, rule);
    },
    true
  );
})();
